export type QCUploadEDTF = {
  uiSchema: {
    type: string;
    elements: {
      type: string;
      scope: string;
    }[];
  };
  schema: {
    type: string;
    properties: Record<
      string,
      {
        type: string;
        format?: EDTF_TYPES;
        title?: string;
        minLength?: number;
      }
    >;
  };
  data: Record<string, string | boolean>;
};

export enum EDTF_TYPES {
  'date' = 'date',
  'date-month' = 'date-month',
}
